(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3776],{

/***/ 3776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ filters; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/index.js + 172 modules
var components = __webpack_require__(70517);
// EXTERNAL MODULE: ./components/filters/Filters.module.scss
var Filters_module = __webpack_require__(10666);
var Filters_module_default = /*#__PURE__*/__webpack_require__.n(Filters_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/filters/Filters.js







var FilterRange = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 5708).then(__webpack_require__.bind(__webpack_require__, 37768));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(37768)];
    }
  }
});
var Help = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9611).then(__webpack_require__.bind(__webpack_require__, 99611));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(99611)];
    }
  }
});
var FilterMultipleCollapsableSearchable = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 4539).then(__webpack_require__.bind(__webpack_require__, 48633));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(48633)];
    }
  }
});
var FiltersTitleWithDescription = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var title = _ref.title,
      description = _ref.description;
  var words = title.split(' ');
  var lastWord = words[words.length - 1];
  var otherWords = words.slice(0, -1).join(' ');
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (Filters_module_default()).title,
    children: description ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [otherWords, ' ', /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "with-description",
        children: [lastWord, /*#__PURE__*/(0,jsx_runtime.jsxs)(Help, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: description
          })]
        })]
      })]
    }) : title
  });
});
var Filters = /*#__PURE__*/(0,react.memo)(function (_ref2) {
  var filters = _ref2.filters,
      onChange = _ref2.onChange,
      selectedFilters = _ref2.selectedFilters,
      _ref2$isSearchPage = _ref2.isSearchPage,
      isSearchPage = _ref2$isSearchPage === void 0 ? false : _ref2$isSearchPage;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (Filters_module_default()).container,
    children: filters.map(function (_ref3, index) {
      var type = _ref3.type,
          id = _ref3.id,
          slug = _ref3.slug,
          title = _ref3.name,
          items = _ref3.options,
          info = _ref3.info;

      switch (type) {
        case 'checkbox':
          return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
            children: (items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
              className: (Filters_module_default()).section,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (Filters_module_default()).block,
                children: [title && slug !== 'mark' && /*#__PURE__*/(0,jsx_runtime.jsx)(FiltersTitleWithDescription, {
                  title: title,
                  description: info
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterMultipleCollapsableSearchable, {
                  name: slug,
                  items: items,
                  selectedFilters: selectedFilters,
                  onChange: onChange,
                  isSearchPage: isSearchPage,
                  title: title
                })]
              })
            })
          }, id || index);

        case 'range':
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
            className: (Filters_module_default()).section,
            children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(FiltersTitleWithDescription, {
              title: title,
              description: info
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterRange, {
              name: slug,
              onChange: onChange,
              selectedFilters: selectedFilters,
              isSearchPage: isSearchPage
            })]
          }, id || index);

        default:
          return null;
      }
    })
  });
});
/* harmony default export */ var filters_Filters = (Filters);
;// CONCATENATED MODULE: ./components/filters/index.js

/* harmony default export */ var filters = (filters_Filters);

/***/ }),

/***/ 10666:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Filters_container__Jbugo","section":"Filters_section__RCQg_","block":"Filters_block__aWW1f","title":"Filters_title__sgPZ0","with-description":"Filters_with-description__znQZM","search":"Filters_search__tZ1Fr","searchReset":"Filters_searchReset__PwZtJ","wrapper":"Filters_wrapper__NS7LS","collapseBtn":"Filters_collapseBtn__Kc6Ke","filterRange":"Filters_filterRange__lqxLc","filterRangeLabel":"Filters_filterRangeLabel__IitM1","mobileRadioWrapper":"Filters_mobileRadioWrapper__cb5jh","load":"Filters_load__FfMew"};

/***/ })

}]);